<template>
  <RevButton
    v-if="isImpersonated"
    size="small"
    :to="{ name: ROUTE_NAMES.BADOOM.HOME, query: { mid: 's' } }"
    variant="secondary"
  >
    {{ i18n(translations.leaveMerchantView) }}
  </RevButton>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'

import { ROUTE_NAMES } from '~/constants/routes'
import { useSellerInfoStore } from '~/scopes/auth/stores/sellerInfoStore'

import translations from './ImpersonatedActions.translations'

const i18n = useI18n()
const { isImpersonated } = useSellerInfoStore()
</script>
